export class Point {
	x: number
	y: number
	constructor(x, y) {
		this.x = x
		this.y = y
	}
}
